module.exports = __webpack_public_path__ + "static/media/LeftArrowPopover.183f8050.svg";